import { Component, ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import theme from 'theme'

interface Props {
  children: ReactNode
  fallbackContent?: string
}

interface State {
  hasError: boolean
}

class MarkdownErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: Props) {
    // Reset error state when content changes (streaming updates)
    if (prevProps.fallbackContent !== this.props.fallbackContent && this.state.hasError) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback - just show the raw content
      return (
        <Box>
          <Typography
            sx={{
              fontFamily: theme.typography.fontFamily.primary,
              fontSize: theme.typography.fontSize.large,
              color: theme.colors.neutral,
              whiteSpace: 'pre-wrap'
            }}
          >
            {this.props.fallbackContent || 'Content loading...'}
          </Typography>
        </Box>
      )
    }

    return this.props.children
  }
}

export default MarkdownErrorBoundary
